import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabViewComponent } from '@app/modules/side-panel/components/tab-view/tab-view.component';
import { TabsContainerComponent } from '@app/modules/side-panel/containers/tabs-container/tabs-container.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommentItemComponent } from '@app/modules/side-panel/components/comment-item/comment-item.component';
import { HistoryItemComponent } from '@app/modules/side-panel/components/history-item/history-item.component';

@NgModule({
  imports: [CommonModule, NgbModule],
  declarations: [
    TabViewComponent,
    TabsContainerComponent,
    CommentItemComponent,
    HistoryItemComponent
  ],
  exports: [TabsContainerComponent]
})
export class SidePanelModule {}
